module.exports = __webpack_public_path__ + "img/depositphotos_25484359-stock-illustration-european-icons-round-flags.863856a8.jpg";